package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import pl.decks.personal.components.widgets.poissondiskgrid.PointMesh
import pl.decks.personal.styles.SiteLayout
import kotlin.math.PI
import kotlin.math.sqrt


@Composable
fun NotesConstellation(
    notes: List<String>,
    constellationFrac: Float = 0.6f,
    modifier: Modifier = Modifier,
) = Column(
    modifier = Modifier.fillMaxWidth().gap(SiteLayout.Space.Small).then(modifier),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    var activeNote by remember { mutableStateOf(0) }
    var visitedNodes by remember { mutableStateOf(setOf(0)) }
    val noEntries = notes.size
    PointMesh(
        minDist = sqrt(15000.0 / (noEntries * PI)),
        maxConnections = 2,
        modifier = Modifier.fillMaxWidth(constellationFrac.times(100).percent).aspectRatio(1),
    ) { ind ->
        if (ind < noEntries) ConstellationPoint(
            when (ind) {
                activeNote -> ForewordStylesheet.Points.CurrentVariant
                in visitedNodes -> ForewordStylesheet.Points.VisitedVariant
                else -> null
            }
        ) {
            activeNote = ind
            visitedNodes = visitedNodes + ind
        }
    }
    NoteText(notes[activeNote])
}

@Composable
private fun ConstellationPoint(
    variant: CssStyleVariant<ForewordStylesheet.Points.Kind>? = null,
    onClick: () -> Unit
) = Box(
    ForewordStylesheet.Points.Base.toModifier(variant)
        .cursor(Cursor.Pointer)
        .onClick { onClick() }
)

@Composable
private fun NoteText(text: String) = Box(
    modifier = ForewordStylesheet.Note.Container.toModifier(),
    contentAlignment = Alignment.TopCenter,
) {
    SpanText(text, modifier = ForewordStylesheet.Note.Text.toModifier())
}
